import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import linkSent from "../../assets/img/linkSent.svg";
import wave from "../../assets/img/wave.svg";
import Button from "@components/Button";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  border: {
    borderWidth: 1,
    borderColor: "#887E7E",
  },
  textColor: {
    color: theme.palette.primary.main,
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  fontSmall: {
    fontSize: "10px",
  },
  bottomImg: {
    position: "fixed",
    bottom: 0,
    right: 0,
    left: 0,
  },
}));

const SignUpVerification = (res) => {
  const classes = useStyles();
  const navigation = useNavigate();
  return (
    <div>
      <div className="m-auto flex w-5/6 flex-col gap-4 md:w-3/12">
        <div className="mt-20">
          <Typography
            variant="h4"
            className={clsx(classes.textColor, " text-center font-extrabold")}
          >
            One More Step
          </Typography>
        </div>
        <div className="mx-auto">
          <img src={linkSent} alt="Link Sent" />
        </div>
        <Typography variant="p" className=" mt-3 text-sm text-center">
          To start building your community with Serkohls, please verify your
          email address using the link Serkohls.com just sent to your registered
          email address
        </Typography>
        <div className="mt-3" onClick={() => navigation("/login-details")}>
          <Button>Login</Button>
        </div>
        <div className={clsx(classes.bottomImg, "block sm:hidden")}>
          <img src={wave} alt="Wave" className="z-0 w-full" />
        </div>
      </div>
    </div>
  );
};

export default SignUpVerification;
